/** Brand name in a specific locale. Without a translation table — just `name`. */
export function brandName(brand, locale) {
    return brand.names?.[locale] ?? brand.name;
}
//# sourceMappingURL=name.js.map